import api from './api';
import {
  Location,
  LocationCreate,
  LocationUpdate,
  DeleteLocationRequest,
  SensorLocationAssignment,
} from '../types';

export const locationService = {
  async getLocations(growerId?: number): Promise<Location[]> {
    const params = growerId ? { grower_id: growerId } : {};
    const response = await api.get<Location[]>('/api/locations/', { params });
    return response.data;
  },

  async getLocation(id: number): Promise<Location> {
    const response = await api.get<Location>(`/api/locations/${id}`);
    return response.data;
  },

  async createLocation(data: LocationCreate): Promise<Location> {
    const response = await api.post<Location>('/api/locations/', data);
    return response.data;
  },

  async updateLocation(id: number, data: LocationUpdate): Promise<Location> {
    const response = await api.put<Location>(`/api/locations/${id}`, data);
    return response.data;
  },

  async deleteLocation(id: number, request: DeleteLocationRequest): Promise<void> {
    await api.delete(`/api/locations/${id}`, { data: request });
  },

  async assignSensorLocation(
    sensorId: number,
    assignment: SensorLocationAssignment
  ): Promise<{ sensor_id: number; location_id: number | null }> {
    const response = await api.patch<{ sensor_id: number; location_id: number | null }>(
      `/api/locations/sensors/${sensorId}/location-assignment`,
      assignment
    );
    return response.data;
  },
};
